<template>
  <v-app>
    <!-- ヘッダー（app で v-main に余白を取らせる） -->
    <v-app-bar color="primary" dark flat app>
      <v-btn style="position: absolute" icon @click="routerBack">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title style="min-width: fit-content;">{{ $t('communication.newBroadcastMessage') }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>

    <v-main>
      <v-container class="new-message-padding-box">
        <!-- 宛先 -->
        <template v-if="allClass">
          <v-select
            class="mt-2"
            variant="outlined"
            :label="$t('form.recipient')"
            v-model="inputAdresses"
            :items="allClass"
            item-title="className"
            item-value="classId"
            color="primary"
            
            chips
            closable-chips
            multiple
          ></v-select>
        </template>

        <!-- タイトル -->
        <v-textarea
          v-model="title"
          :label="$t('form.title')"
          variant="outlined"
          :rules="[rules.required]"
          rows="2"
          hide-details
          dense
          class="mb-5"
          color="primary"
        ></v-textarea>

        <!-- 内容 -->
        <v-textarea
          :label="$t('form.content')"
          variant="outlined"
          rows="17"
          hide-details
          dense
          v-model="inputText"
          color="primary"
        ></v-textarea>

        <div v-if="!isChatCreateUserMe" class="primary--text font-weight-bold">{{ $t('communication.viewOnly') }}</div>

        <!-- {{ $t('communication.send') }}/{{ $t('communication.draft') }} -->
        <MessageHandle
          @saveDraft="saveDraft"
          @saveSendReady="saveSendReady"
          @sendMessage="sendMessage"
          :btnSendLoading="btnSendLoading"
          :btnDraftLoading="btnDraftLoading"
          :btnReadyLoading="btnReadyLoading"
          :inputText="inputText"
          :isChatCreateUserMe="isChatCreateUserMe"
        />
      </v-container>
    </v-main>
    <v-snackbar v-model="snackbar" :timeout="timeout" outlined top color="primary">
      {{ snackBarText }}

      <!-- <template v-slot:action="{ attrs }">
        <v-btn color="primary" text v-bind="attrs" @click="snackbar = false">
          ×
        </v-btn>
      </template> -->
      <template v-slot:actions>
        <v-btn
          color="outline-primary"
          variant="text"
          @click="snackbar = false"
        >
          ×
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from "vue";
import MessageHandle from '@/components/MessageHandle.vue';
import LocalDataService from '@/service/LocalDataService';
import { nurseryModule } from '@/store/dataModules/nurseryModule';
import { GroupChatResponse, NurseryClassResponse } from 'chaild-api/lib';
import { chatModule } from '@/store/dataModules/chatModule';
import rules from '@/service/ValidRules';

import dayjs from 'dayjs';

interface Address {
  id: string;
  name: string;
}

export default defineComponent({
  components: {
    MessageHandle,
  },

  data: () => {
    return {
      date: '' as any,
      inputAdresses: [] as number[],
      inputText: '',
      timeout: 2000,
      snackBarText: '',
      snackbar: false,
      btnSendLoading: false,
      btnDraftLoading: false,
      btnReadyLoading: false,
      draftBulkChatId: '',
      readyBulkChatId: '',
      title: '',
      toClass: false,
    };
  },

  computed: {
    allClass(): NurseryClassResponse[] | null {
      if (nurseryModule.allClasses) {
        return nurseryModule.allClasses;
      }
      return null;
    },
    bulkChatsDraft(): GroupChatResponse[] {
      if (chatModule.bulkChatsDraft) {
        return chatModule.bulkChatsDraft;
      }
      return [];
    },
    bulkChatsReady(): GroupChatResponse[] {
      if (chatModule.bulkChatsReady) {
        return chatModule.bulkChatsReady;
      }
      return [];
    },
    isChatCreateUserMe(): boolean {
      const queryUserId = this.$route.query.userId as string;
      const user = LocalDataService.getUser();
      if (queryUserId && user) {
        let nurserySchool = user.nurserySchools.find(nursery => nursery.isDefault === true);
        if (!nurserySchool) {
          nurserySchool = user.nurserySchools[0];
        }
        const myUserId = nurserySchool.userId.toString();
        if (myUserId === queryUserId) {
          return true;
        }
        return false;
      }
      return true;
    },
    rules() {
      return rules;
    },
  },

  methods: {
    async routerBack() {
      this.snackbar = false;
      const routes = window.history.length;
      await sessionStorage.setItem('targetTab', 'message');
      this.$router.push('/')
    },
    remove(item: NurseryClassResponse) {
      const index = this.inputAdresses.findIndex(addressId => addressId === item.classId);
      if (index >= 0) {
        this.inputAdresses.splice(index, 1);
      }
    },
    saveDraft: async function() {
      if (this.inputText) {
        try {
          this.btnDraftLoading = true;
          if (this.draftBulkChatId) {
            await chatModule.saveAllChatDraft({
              groupChatId: Number(this.draftBulkChatId),
              body: this.inputText,
              ...(this.toClass && {classIds: this.inputAdresses}),
              title: this.title? this.title : null,
            });
            this.$router.push(`/communication/new-message`);
          } else {
            const classIds = this.inputAdresses.filter((address) => {
              const findFromClassOptions = this.allClass?.find((c) => c.classId === address)
              if (findFromClassOptions) {
                return true
              }
              return false
            })
            await chatModule.saveAllChatDraft({
              // childIds: this.childId,
              classIds,
              date: this.date.format('YYYY-MM-DD'),
              body: this.inputText,
              ...(this.title && {title: this.title}),
            });
          }
          this.snackBarText = (this as any).$t('communication.savedToDraft');
          this.snackbar = true;
          this.inputText = '';
          this.title = '';
        } catch {
        } finally {
          this.btnDraftLoading = false;
        }
      }
    },
    saveSendReady: async function() {
      if (this.inputText) {
        try {
          this.btnReadyLoading = true;
          if (this.readyBulkChatId) {
            console.log({
              classIds: this.inputAdresses,
              date: this.date.format('YYYY-MM-DD'),
              body: this.inputText,
            });
            await chatModule.updateAllChatReady({
              groupChatId: this.readyBulkChatId,
              body: this.inputText,
              classIds: this.inputAdresses,
              title: this.title? this.title : null,
            });
            this.$router.push(`/communication/new-message`);
          } else {
            const classIds = this.inputAdresses.filter((address) => {
              const findFromClassOptions = this.allClass?.find((c) => c.classId === address)
              if (findFromClassOptions) {
                return true
              }
              return false
            })
            await chatModule.saveAllChatReady({
              // childIds: this.childId,
              classIds,
              date: this.date.format('YYYY-MM-DD'),
              body: this.inputText,
              ...(this.title && {title: this.title}),
            });
          }
          this.snackBarText = (this as any).$t('communication.savedToReadySend');
          this.snackbar = true;
          this.inputText = '';
          this.title = '';
        } catch {
        } finally {
          this.btnReadyLoading = false;
        }
      }
    },
    sendMessage: async function() {
      if (this.inputText) {
        try {
          this.btnSendLoading = true;
          const classIds = this.inputAdresses.filter((address) => {
              const findFromClassOptions = this.allClass?.find((c) => c.classId === address)
              if (findFromClassOptions) {
                return true
              }
              return false
            })
          if (this.draftBulkChatId) {
            await chatModule.saveAllChatDraft({
              groupChatId: Number(this.draftBulkChatId),
              body: this.inputText,
              classIds,
              title: this.title? this.title : null,
            });
            const ids = [Number(this.draftBulkChatId)];
            await chatModule.sendAllChat({
              groupChatIds: ids,
            });
          } else if (this.readyBulkChatId) {
            await chatModule.updateAllChatReady({
              groupChatId: this.readyBulkChatId,
              body: this.inputText,
              classIds,
              title: this.title? this.title : null,
            });
            const ids = [Number(this.readyBulkChatId)];
            await chatModule.sendAllChat({
              groupChatIds: ids,
            });
          } else {
            await chatModule.sendAllChat({
              // childIds: this.childId,
              classIds,
              date: this.date.format('YYYY-MM-DD'),
              body: this.inputText,
              ...(this.title && {title: this.title}),
            });
          }
          this.snackBarText = (this as any).$t('communication.sentSuccess');
          this.snackbar = true;
          this.inputText = '';
          this.title = '';
          this.inputAdresses = []
        } catch {
        } finally {
          this.btnSendLoading = false;
        }
      }
    },
  },

  async created() {
    this.date = dayjs();
  },

  async mounted() {
    const localText = LocalDataService.getBulkChatText();
    if (localText) {
      this.inputText = localText;
    }
    const localAddress = LocalDataService.getBulkChatAddress();
    if (localAddress) {
      this.inputAdresses = localAddress;
    }
    const user = LocalDataService.getUser();
    if (user) {
      let nurserySchool = user.nurserySchools.find(nursery => nursery.isDefault === true);
      if (!nurserySchool) {
        nurserySchool = user.nurserySchools[0];
      }
      const nurseryId = nurserySchool.nurseryId;
      await nurseryModule.getNurseryClass(nurseryId);

      // 下書きからの遷移の場合(一斉)
      this.draftBulkChatId = this.$route.query.draftBulkChatId as string;
      if (this.draftBulkChatId) {
        await chatModule.getAllChatDraft({ nurseryId });
        if (this.draftBulkChatId && this.bulkChatsDraft.length > 0) {
          const find = this.bulkChatsDraft.find(
            chat => chat.groupChatId === Number(this.draftBulkChatId)
          );
          if (find) {
            this.inputAdresses = [];
            find.to.classes.map(clas => {
              this.inputAdresses.push(clas.classId);
              this.toClass = true;
            });
            find.to.children.map(child => {
              this.inputAdresses.push(child.childId);
            });
            this.inputText = find.body;
            if(find.title) {
              this.title = find.title;
            }
          }
        }
      }

      // 送信準備からの遷移の場合(一斉)
      this.readyBulkChatId = this.$route.query.readyBulkChatId as string;
      if (this.readyBulkChatId) {
        await chatModule.getAllChatReady({ nurseryId });
        if (this.readyBulkChatId && this.bulkChatsReady.length > 0) {
          const find = this.bulkChatsReady.find(
            chat => chat.groupChatId === Number(this.readyBulkChatId)
          );
          if (find) {
            this.inputAdresses = [];
            find.to.classes.map(clas => {
              this.inputAdresses.push(clas.classId);
            });
            find.to.children.map(child => {
              this.inputAdresses.push(child.childId);
            });
            this.inputText = find.body;
            if(find.title) {
              this.title = find.title;
            }
          }
        }
      }
    }
  },

  beforeDestroy() {
    if (this.inputText) {
      LocalDataService.setBulkChatText(this.inputText);
    } else {
      LocalDataService.removeBulkChatText();
    }
    if (this.inputAdresses.length > 0) {
      const classIds = this.inputAdresses.filter((address) => {
        const findFromClassOptions = this.allClass?.find((c) => c.classId === address)
        if (findFromClassOptions) {
          return true
        }
        return false
      })
      LocalDataService.setBulkChatAddress(classIds);
    } else {
      LocalDataService.removeBulkChatAddress();
    }
  },
});
</script>
<style lang="scss" scoped>
@use '@/sass/ress.scss' as *;
@use '@/sass/variables.scss' as *;

/* v-app-bar が v-main と被らないよう余白を確保 */
.new-message-padding-box {
  padding-top: 68px;
  padding-left: 16px;
  padding-right: 16px;
}
</style>
